export * from './teses-juridicas-chat'
